import LocalForage from 'localforage'

import { DATABASE_NAME, DATABASE_VERSION } from './constants'

LocalForage.config({
	name: DATABASE_NAME,
	version: DATABASE_VERSION
})

export const database = LocalForage
